import React from "react"
import Spinner from "./Spinner"

function Loading({ error }: { error?: string | null }) {
  if (!error) {
    return <Spinner />
  }

  return <div className="errorBox">{error}</div>
}

export default Loading
